import { asset } from "@/lib/asset";
import React from 'react';
import {VideoParagraph } from '../components/Blog/Paragraphs/VideoParagraph';

const Education = () => {
    return (
        <div className="container mx-auto px-4 py-8">
            <div className="text-[32px] xl:text-[44px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[40px]">
                Топ-7 функций «Ключ-Астром»
            </div>

            <div className="py-3">
                APM включает в себя мониторинг как технической производительности приложения, так и анализ восприятия сайта или приложения пользователями. Поскольку современные приложения работают на высокораспределенной инфраструктуре, все их компоненты находятся в постоянном движении и очень сложны для мониторинга, поэтому программное обеспечение от «Ключ-Астром» охватывает 
                <span className="bold">
                    все критические части приложения: доступность систем, производительность и поведение пользователя.
                </span>
            </div>

            <div className="my-5">
                <div className="text-[20px] xl:text-[24px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[40px]">
                    Доступность сайта
                </div>

                <div className="">Она показывает доступность сервиса и услуг для ваших клиентов по всему миру. Если ваш сервис недоступен в режиме онлайн, то пользователи покидают сайт. Поисковые системы могут решить, что ваш сайт ненадежен, и это также может негативно повлиять на поисковую выдачу.
                </div>

                
                <div className="w-full mt-3 px-0">
                    <VideoParagraph text={`«Как оценить доступность сервиса, то есть что все услуги на сайте доступны?»`} src={asset(`/img/videos/kak_otsenivat_dostup_cervis.mp4`)} />
                </div>
            </div>

            <div className="my-5" id="error-search">
                <div className="text-[20px] xl:text-[24px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[40px]">
                    Поиск и предупреждение ошибок
                </div>

                <p className="">
                    Интерфейс «Ключ-Астром» позволяет каждую проблему рассмотреть с максимально возможной детализацией причин. Можно увидеть источник проблемы, и как она разрасталась внутри сайта или приложения; сколько пользователей и где она затронула; какие компоненты системы были затронуты; установить продолжительность простоя системы или отдельных её частей.
                </p>
                <p className="mt-3">
                    Система позволяет как оценить количество пользователей, которых затронули ошибки на странице, так и идентифицировать эти ошибки.
                </p>
                
                <div className="w-full mt-3 px-0">
                    <VideoParagraph text={`Как быстро анализировать IT-инфраструктуру сайта или приложения?`} src={asset(`/img/videos/kak_bistro_analizirovat_it_infra_saita_ili_prilozhenie.mp4`)} />
                </div>
                
                <div className="w-full mt-3 px-0">
                    {/* {% set text, src = international("Как моментально найти ошибку в коде?"), "/img/videos/6DBPSGS3KNk" %} */}
                    <VideoParagraph text={`Как моментально найти ошибку в коде?`} src={asset(`/img/videos/kak_momentalno_naiti_oshibku_v_kode.mp4`)} />
                </div>
            </div>

            <div className="my-5" id="monitoring">
                <div className="text-[20px] xl:text-[24px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[40px]">
                    Система мониторинга цифрового опыта
                </div>

                <p className="">
                    Раньше аналитики компании оперировали обобщенными данными о пользователях. Да, вы понимали сколько пользователей заходило или совершало покупки, но многое оставалось за пределами внимания компании.
                </p>
                <p className="mt-3">
                    Мониторинг пользовательского опыта «Ключ-Астром» позволяет получить куда более детальную информацию о поведении пользователей в режиме реального времени. Теперь и у IT-команды, и у аналитиков, и у отделов продаж будут наглядные данные, соответствующие их профилям, и одновременно доступные всем командам для обсуждений и исправлений.
                </p>
                <p className="mt-3">
                    Это глобально отличает аналитику APM от стандартных аналитических платформ. Данные о пользовательском опыте соединяются здесь с работой бэкенда системы.
                </p>

                
                <div className="w-full mt-3 px-0">
                    {/* {% set text, src = international("«Как анализировать цифровое поведение» пользователей?"), "/img/videos/157cRXTOdxE" %}
                    {% include 'components/%s/cards/video.html' % session.get("language", "ru")%} */}
                    <VideoParagraph text={`«Как анализировать цифровое поведение» пользователей?`} src={asset(`/img/videos/kak_analizirovat_tsifravoe_povedenie_polsovatelei.mp4`)} />
                </div>


                
                <div className="w-full mt-3 px-0">
                    {/* {% set text, src = international("«Как контролировать бизнес-операции?»"), "/img/videos/gfNsJ3bV4as" %}
                    {% include 'components/%s/cards/video.html' % session.get("language", "ru")%} */}
                    <VideoParagraph text={`«Как контролировать бизнес-операции?»`} src={asset(`/img/videos/kak_kontrolirovat_biznes_operatsii.mp4`)} />
                </div>

                
                <div className="w-full mt-3 px-0">
                    {/* {% set text, src = international("«Как оценить эффективность маркетинговой кампании?»"), "/img/videos/huE8A1XDuOU" %}
                    {% include 'components/%s/cards/video.html' % session.get("language", "ru")%} */}
                    <VideoParagraph text={`«Как оценить эффективность маркетинговой кампании?»`} src={asset(`/img/videos/kak_otsenit_effectivnostii_marketingovoi_kompanii.mp4`)} />
                </div>
            </div>

            <div className="" id="sales">
                <div className="text-[20px] xl:text-[24px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[40px]">
                    Продажи
                </div>

                <p className="">
                    Вы разработали предложение, привлекли внимание клиентов, привлекли их на сайт и довели их до корзины… и они упали на последней ступеньке. Что произошло? Раньше надо было строить гипотезы о причинах снижения продаж. Изучив поведение пользователя, «Ключ-Астром» выстроит воронку по ключевым действиям пользователей на сайте. Теперь легко понять, на каком шаге возникла проблема.
                </p>
                
                <div className="w-full mt-3 px-0">
                    {/* {% set text, src = international("«Как построить воронку продаж?»"), "/img/videos/zpPZQd5OgCo" %}
                    {% include 'components/%s/cards/video.html' % session.get("language", "ru")%} */}
                    <VideoParagraph text={`«Как построить воронку продаж?»`} src={asset(`/img/videos/kak_postroit_voronku_prodazh.mp4`)} />
                </div>
            </div>
        </div>

    );
};

export default Education;

